import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { PageToPageEditView } from './views/PageToPageEditView';
import { PageToPageDefaultView } from './views/PageToPageDefaultView';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';

export type PageToPage = Views<DefaultView<PageToPageDefaultView> & OptionalEditView<PageToPageEditView>>;

export function PageToPage({ views }: PageToPage) {
  const {
    editModeInfo: { active },
  } = useAppContext();

  return views.edit && active ? <PageToPageEditView {...views.edit} /> : <PageToPageDefaultView {...views.default} />;
}

/**
 * Block to connect Pages with Pages.
 */
export const PageToPageBlock = asFetchableBlock(PageToPage, BlockType.pageToPage);
export type PageToPageBlock = ComponentProps<typeof PageToPageBlock>;
